import React, { useState, useEffect, useContext } from 'react'
import toast from 'react-hot-toast'
import { Dropdown } from 'semantic-ui-react'
import PatientAccountService from '../../../../../../../../services/api/patient-account.service'
import ModalBox from '../../../../../../../templates/components/ModalBox'
import PatientAccountEdit from '../../../../../patient-account/patient-account-edit/PatientAccountEdit'
import { store } from '../../../../../../../../context/StateProvider'
import APIResponse from '../../../../../../../templates/components/APIResponse'
import PatientAccountRenew from '../../../../../patient-account/patient-account-renew/PatientAccountRenew'

const WalletCard = (props) => {
    let detail = props.detail
    const [editCard, setEditCard] = useState(false)
    const [renewCard, setRenewCard] = useState(false)
    const [deactivate, setDeactivate] = useState(false)
    const [activate, setActivate] = useState(false)
    const [deleteAccount, setDeleteAccount] = useState(false)
    const state = useContext(store).state
    const [apiResponse, setApiResponse] = useState()

    const icons = {
        BLANK: 'credit-card',
        AMEX: 'cc amex',
        DINERS: 'cc diners club',
        DISCOVER: 'cc discover',
        JCB: 'cc jcb',
        MASTERCARD: 'cc mastercard',
        VISA: 'cc visa',
        '': 'money bill',
        getIcon: (cardType) => {
            return cardType ? icons[cardType.toUpperCase()] || icons.BLANK : icons[''];
        }
    }

    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const activatePatientAccount = () => {
        PatientAccountService.activatePatientAccount(props.patientId, props.detail.id)
        .then(response => {
            setApiResponse(response)
        })
        .catch(error => {
            setApiResponse(error)
        })
        .finally(() => {
            setActivate(false)
        });
    }

    const deactivatePatientAccount = () => {
        PatientAccountService.inactivatePatientAccount(props.patientId, props.detail.id)
        .then(response => {
            setApiResponse(response)
        })
        .catch(error => {
            setApiResponse(error)
        })
        .finally(() => {
            setDeactivate(false)
        });
    }

    const deletePatientAccount = () => {
        PatientAccountService.deletePatientAccount(props.patientId, props.detail.id)
        .then(response => {
            setApiResponse(response)
        })
        .catch(error => {
            setApiResponse(error)
        })
        .finally(() => {
            setDeleteAccount(false)
        });
    }

    return (
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <i className={`icon large ${icons.getIcon(detail.cardType)}`} />
                    </div>
                    <div>
                        <span className={`badge ${detail.isActive ? 'bg-success' : 'bg-danger'}`}>
                            {detail.isActive ? "Active" : "Inactive"}
                        </span>
                    </div>
                </div>

                <div className="text-center mb-3">
                    <h6 className="fw-normal mb-2">{detail.accountHolderName}</h6>
                    {detail.maskedCardNumber && 
                        <div className="text-muted small">****-****-****-{detail.maskedCardNumber}</div>
                    }
                    {detail.maskedAccountNo && 
                        <div className="text-muted small">Account Ending In {detail.maskedAccountNo}</div>
                    }
                </div>

                <div className="mb-3">
                    {detail.cardExpiry && (
                        <div className="text-muted small mb-1">
                            Valid Through: {detail?.cardExpiry?.toString().substr(0, 2)}/{detail?.cardExpiry?.toString().substr(2, 2)}
                        </div>
                    )}
                    {detail.bankName && (
                        <div className="text-muted small mb-1">
                            Bank: {detail.bankName}
                        </div>
                    )}
                    {detail.practiceLocationId && state.practiceLocations?.length > 1 && (
                        <div className="text-muted small mb-1">
                            Location: {state?.practiceLocations?.find(obj => obj.practiceLocationId == detail.practiceLocationId)?.practiceLocation}
                        </div>
                    )}
                </div>

                <div className="btn-group w-100">
                    {detail.isActive === 1 ? 
                        <button className="btn btn-primary" title="Deactivate" onClick={e => { e.preventDefault(); setDeactivate(true) }}>
                            <i className="icon ban"></i>
                        </button> :
                        <button className="btn btn-primary" title="Activate" onClick={e => { e.preventDefault(); setActivate(true) }}>
                            <i className="icon power"></i>
                        </button>
                    }
                    {detail.isActive === 1 && 
                        <button className="btn btn-primary" title="Change Card Info" onClick={e => { e.preventDefault(); setEditCard(true) }}>
                            <i className="icon pencil"></i>
                        </button>
                    }
                    <button className="btn btn-primary" title="Delete Account" onClick={e => { e.preventDefault(); setDeleteAccount(true) }}>
                        <i className="icon trash alternate outline"></i>
                    </button>
                    {detail.isActive === 1 && detail.accountType == 1 && 
                        <button className="btn btn-primary" title="Renew Account" onClick={e => { e.preventDefault(); setRenewCard(true) }}>
                            <i className="sync icon"></i>
                        </button>
                    }
                </div>
            </div>

            <ModalBox open={editCard} onClose={() => { setEditCard(false) }} title="Edit Patient Account">
                <PatientAccountEdit account={detail} patientId={props.patientId} onClose={() => { setEditCard(false) }} refresh={() => { if(props.refresh) props.refresh() }}/>
            </ModalBox>
            <ModalBox open={renewCard} onClose={() => { setRenewCard(false) }} title="Renew Patient Account">
                <PatientAccountRenew account={detail} patientId={props.patientId} onClose={() => { setRenewCard(false) }} refresh={() => { if(props.refresh) props.refresh() }}/>
            </ModalBox>
            <ModalBox open={deactivate} onClose={() => { setDeactivate(false) }} size="small" confirmButton="Yes" onCloseSuccess={() => { deactivatePatientAccount(); }} title="Deactivate Patient Account">
                Are you sure you want to deactivate this card?
            </ModalBox>
            <ModalBox open={activate} onClose={() => { setActivate(false) }} size="small" confirmButton="Yes" onCloseSuccess={() => { activatePatientAccount(); }} title="Activate Patient Account">
                Are you sure you want to activate this card?
            </ModalBox>
            <ModalBox open={deleteAccount} onClose={() => { setDeleteAccount(false) }} size="small" confirmButton="Yes" onCloseSuccess={() => { deletePatientAccount(); }} title="Delete Patient Account">
                Are you sure you want to permanently delete this card?
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </div>
    )
}

export default WalletCard